import { useLingui } from "@lingui/react";
import { ApiDatafanPipeline, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "datafan.pipeline.mapping";

type Response = Await<ReturnType<typeof ApiDatafanPipeline.Mapping.get>>;
type ResponseSelect = { [key: string]: Response[number] };

export const useQueryDatafanPipelineMapping = (
  pipelineId?: string | number,
  options?: Omit<
    UseQueryOptions<Response, FailureApi, ResponseSelect>,
    "queryKey" | "queryFn" | "select"
  >,
) => {
  const { i18n } = useLingui();
  const lang = i18n.locale === "ru" ? "ru" : "en";

  return useQuery<Response, FailureApi, ResponseSelect>(
    [KEY, pipelineId],
    () =>
      ApiDatafanPipeline.Mapping.get({
        path: { id: Number(pipelineId) },
        query: { lang },
      }),
    {
      ...options,
      enabled: pipelineId !== undefined && options?.enabled !== false,
      select: (data) =>
        data.reduce((acc, item) => {
          acc[item.name] = item;

          return acc;
        }, {} as ResponseSelect),
    },
  );
};

useQueryDatafanPipelineMapping.KEY = KEY;
